<script setup lang="ts">
import { computed } from "vue";
import foot_logo from "@image/memberFunction/02_web/foot_logo.png";

// SEO 錨點：有設 VITE_CONFIG_SEO_LINK_URL 的品牌，頁尾多一條站名外連
const SeoLinkUrl = computed(() => {
  return import.meta.env.VITE_CONFIG_SEO_LINK_URL || "";
});
const BuildName = computed(() => {
  return import.meta.env.VITE_CONFIG_BUILD_NAME || "";
});
</script>
<template>
  <footer class="bg-[url('@image/memberFunction/02_web/ground.png')] flex-col justify-center items-center">
    <div class="flex flex-col justify-center items-center mt-[3dvh]">
      <img v-img-src="foot_logo" alt="" class="max-w-[80%]" />
    </div>
    <div class="w-[80vw] h-[3px] bg-white my-[3dvh]"></div>
    <ul class="flex items-center justify-center mb-[3dvh]">
      <li class="mr-[32px]">
        <button
          class="text-[16px] text-primary/80 relative after:absolute after:h-full after:w-[1px] after:bg-white after:-right-[25%] after:-translate-x-1/2"
          disabled>
          {{ $t("Footer.Terms") }}
        </button>
      </li>
      <li class="mr-[32px]">
        <button
          class="text-[16px] text-primary/80 relative after:absolute after:h-full after:w-[1px] after:bg-white after:-right-[25%] after:-translate-x-1/2"
          disabled>
          {{ $t("Footer.Privacy") }}
        </button>
      </li>
      <li class="mr-[32px]">
        <button
          class="text-[16px] text-primary/80 relative after:absolute after:h-full after:w-[1px] after:bg-white after:-right-[25%] after:-translate-x-1/2"
          disabled>
          {{ $t("Footer.Disclaimer") }}
        </button>
      </li>
      <li class="mr-[32px]">
        <button
          class="text-[16px] text-primary/80 relative after:absolute after:h-full after:w-[1px] after:bg-white after:-right-[25%] after:-translate-x-1/2"
          disabled>
          {{ $t("Footer.TechnicalIssues") }}
        </button>
      </li>
      <li class="mr-[32px]">
        <button
          class="text-[16px] text-primary/80 relative after:absolute after:h-full after:w-[1px] after:bg-white after:-right-[25%] after:-translate-x-1/2"
          disabled>
          {{ $t("Footer.Issues") }}
        </button>
      </li>
      <li>
        <button class="text-[16px] text-primary/80 relative" disabled>
          {{ $t("Footer.ContactUs") }}
        </button>
      </li>
    </ul>
    <p v-if="SeoLinkUrl" class="text-center text-[12px] text-primary/80 mb-[1dvh]">
      <a :href="SeoLinkUrl" target="_blank" rel="noopener">{{ BuildName }}</a>
    </p>
    <p class="text-center text-[12px] text-primary/80 mb-[3dvh]">
      {{ $t("Footer.Copyright") }}
    </p>
  </footer>
</template>

<style>
.bg-100 {
  background-size: 100% 100%;
}
</style>
